import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type UseUpdateTrackableFileAvailabilityParams = {
  trackable_list_id: string;
  trackable_item_id: string;
  trackable_file_id: string;
};

export function useUpdateTrackableFileAvailability({
  onSuccess,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, UseUpdateTrackableFileAvailabilityParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, trackable_item_id, trackable_file_id }: UseUpdateTrackableFileAvailabilityParams) => {
      const url = `/apps/${applicationID}/trackables/${trackable_list_id}/items/${trackable_item_id}/files/${trackable_file_id}/update_availability`;
      await client.post(url);
    },
    {
      ...options,
      onSuccess: (...args) => {
        onSuccess?.(...args);
        queryClient.invalidateQueries(['trackable-files']);
      },
      onError,
      onSettled,
    }
  );
}